import { cloneElement } from 'react';
import { useGetIdentity, usePermissions } from 'react-admin';

const Permission = ({ print = false, permission = '', userRole = '', children, ...props }) => {
  const { permissions: userPermissions } = usePermissions();
  const { identity } = useGetIdentity();
  let granted = true;

  if (permission && userPermissions && !userPermissions.includes(permission)) {
    granted = false;
  }

  if (identity && userRole && userRole !== identity.role) {
    granted = false;
  }

  return granted ? cloneElement(children, props) : null;
}
export default Permission;